<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="grow-up-menu">
    <div
      class="background-opacity"
      :class="mobileFiltersOpen && 'menu-grow'"
      @click="closeMobileFilter"
    />
    <div class="menu-wrapper" :class="mobileFiltersOpen && 'menu-grow'">
      <div class="header-filter-mobile" @click="closeMobileFilter">
        <div class="header-filter-mobile-text" :class="!showFixedButtons && 'header-text-bold'">{{ titleMenu }}</div>
        <div class="header-filter-mobile-icon" />  
      </div> 
      <div class="options-wrapper" :class="!showFixedButtons && 'small-padding-bottom'">
        <slot name="menu-options" />
        
        <div v-if="showFixedButtons" class="mobile-buttons-wrapper">
          <div class="mobile-button button-white" @click="cleanFilters ? cleanFilters : closeMobileFilter">{{ $t(cleanFilters ? 'btn_clean' : 'cancel') }}</div>
          <div class="mobile-button button-black" @click="closeMobileFilter">{{ $t('btn_apply') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GrowUpMenu',
  props: {
    mobileFiltersOpen: {
      type: Boolean,
    },
    cleanFilters: {
      type: Function,
    },
    titleMenu: {
      type: String,
    },
    showFixedButtons: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    /**
     * Close mobile filter
     * @public This is a public method
     * @param {String} filter Id of selected filter to toggle
     */
    closeMobileFilter() {
      /** Triggers event to toggle
       * @event toggle-mobile-filter
       */
      this.$emit('toggle-mobile-filter', false)
    },
  },
}
</script>

<style lang="stylus" scoped>
.grow-up-menu
  position: relative
  border-radius: 6px
  background-color: #fff
  box-shadow: 0 4px 80px rgba(#000, 0.05)

  .background-opacity
    position: fixed
    top: 0
    left: 0
    z-index: 6
    width: 100vw
    height: 100vh
    background-color: rgba($grey-dark, 0.7)
    content: ""
    opacity: 0
    transition: opacity 0.25s ease-in-out
    pointer-events: none

    &.menu-grow
      opacity: 1
      pointer-events: all

  .menu-wrapper
    position: fixed
    bottom: 0
    left: 0
    z-index: 11
    padding-top: 0
    padding-top: vw(8px)
    width: 100%
    border-radius: vw(8px) vw(8px) 0 0
    background-color: #fff
    transition: transform 0.25s ease-in-out
    transform: translateY(100%)

    &.menu-grow
      transform: translateY(0)

    .options-wrapper
      position: relative
      overflow-y: auto
      padding-bottom: vw(80px)
      max-height: 92vh

    .small-padding-bottom
      padding-bottom: vw(40px)

    .header-filter-mobile
      display: flex
      justify-content: space-between
      padding: vw(20px) vw(20px) 0
      width: 100%

      .header-text-bold
        font-weight: 600
        m-font-size(18, 20)

      .header-filter-mobile-icon
        m-icon("close", 20)

      .header-filter-mobile-text
        m-font-size(16, 20)
        color: $grey

    .mobile-buttons-wrapper
      position: fixed
      bottom: 0
      left: 0
      display: flex
      justify-content: space-between
      padding: vw(15px)
      width: 100%
      background-color: #fff

      .mobile-button
        display: flex
        justify-content: center
        padding: vw(10px)
        width: 49%
        border: 1px solid black
        border-radius: 4px

        span
          m-font-size(14, 20)

      .button-white
        background-color: #fff
        color: black

      .button-black
        background-color: black
        color: #fff
</style>